export default __webpack_public_path__ + "static/media/logo_fb.9bc10054.png";